function UserNavIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" id="userManagement">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M.833 16.667v-.834A5.833 5.833 0 016.667 10v0a5.833 5.833 0 015.833 5.833v.834"
      ></path>
      <path stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" d="M10.833 11.667v0A4.167 4.167 0 0115 7.5v0a4.167 4.167 0 014.167 4.167v.416"></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M6.667 10a3.333 3.333 0 100-6.667 3.333 3.333 0 000 6.667zM15 7.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
      ></path>
    </svg>
  );
}

export default UserNavIcon;
